import { IncludedProducts as IncludedProducts$2, ProductsTitle, Products, Product, ProductImageWrapper, ProductContentWrapper, ProductTitle, ProductSubtitle } from './IncludedProducts.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Typography from '../../Typography/Typography.js';
import CloudinaryPicture from '../../Picture/CloudinaryPicture.js';
import Rating from '../../Rating/Rating.js';
import useUniqueId from '../../../hooks/useUniqueId.js';

var IncludedProducts = function IncludedProducts(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title,
    products = _ref.products;
  return /*#__PURE__*/jsxs(IncludedProducts$2, {
    children: [title && /*#__PURE__*/jsx(ProductsTitle, {
      as: Typography,
      variant: "mini",
      children: title
    }), /*#__PURE__*/jsx(Products, {
      children: products.map(function (product) {
        return /*#__PURE__*/jsxs(Product, {
          children: [/*#__PURE__*/jsx(ProductImageWrapper, {
            as: CloudinaryPicture,
            img: product.image,
            sizes: [{
              height: 95,
              width: 100
            }],
            retina: true
          }), /*#__PURE__*/jsxs(ProductContentWrapper, {
            children: [/*#__PURE__*/jsx(ProductTitle, {
              children: product.title
            }), /*#__PURE__*/jsx(ProductSubtitle, {
              children: product.subtitle
            }), /*#__PURE__*/jsx(Rating, {
              size: "s",
              rating: product.rating
            })]
          })]
        }, useUniqueId('product'));
      })
    })]
  });
};
var IncludedProducts$1 = IncludedProducts;

export { IncludedProducts$1 as default };
//# sourceMappingURL=IncludedProducts.js.map
